import { useState } from "react";
import { useAppSelector } from "../../../app/hooks";
import ProgressIcon from "../../../assets/ProgressIcon";
import PromptsIcon from "../../../assets/PromptsIcon";
import UsageIcon from "../../../assets/UsageIcon";
import PerformanceIcon from "../../../assets/PerformanceIcon";
import RtkqResultViewer from "../../../components/RtkqResultViewer";
import { SelectDevelopmentView } from "../../../components/input/SelectDevelopmentView";

import {
	USAGE_SUMMARY,
	USAGE_WRITING,
	USAGE_PEER_REVIEWS,
	USAGE_LESSONS,
} from "./usage/UsageReport";
import {
	STUDENT_TRAIT_AND_TOTAL_SCORES,
	STUDENT_WRITING_GENRE_SCORES,
	STUDENT_CR_SCORES,
} from "./performance/PerformanceReport";
import { ESSAY_DRAFT_HISTORY_SECTION } from "./progress/essayDraftHistory/EssayDraftHistory";
import { STUDENT_AVERAGE_MONTHLY_SCORES } from "./progress/ProgressReport";
import { STUDENT_PROMPT_ANALYSIS, STUDENT_CR_PROMPT_ANALYSIS } from "./prompt/PromptReport";

import { ReportBlockConfig, ReportBlock } from "../shared/ReportBlock";
import { useReportsPageQuery } from "../reportsApiSlice";

export default function StudentReports() {
	const [view, setView] = useState<string>("legacy");

	const { config } = useAppSelector((state) => state.site);

	const result = useReportsPageQuery();
	const data = result.data;

	const reportBlocks: ReportBlockConfig[] = [
		{
			heading: "Usage",
			Icon: UsageIcon,
			link: "/reports/student/usage",
			links: [
				{
					text: "Summary",
					section: USAGE_SUMMARY,
				},
				{
					text: "Writing",
					section: USAGE_WRITING,
				},
				{
					text: "Peer Reviews",
					section: USAGE_PEER_REVIEWS,
				},
				{
					text: "Lessons",
					section: USAGE_LESSONS,
				},
			],
		},
		{
			heading: "Performance",
			Icon: PerformanceIcon,
			link: "/reports/student/performance",
			links: [
				{
					text: `${config?.isUtahComposeSite ? "Analytical" : "Trait"} and Total Scores`,
					section: STUDENT_TRAIT_AND_TOTAL_SCORES,
				},
				{
					text: "Constructed Response Scores",
					section: STUDENT_CR_SCORES,
				},
				{
					text: "Writing Genre Scores",
					section: STUDENT_WRITING_GENRE_SCORES,
				},
			],
		},
		{
			heading: "Prompts",
			Icon: PromptsIcon,
			link: "/reports/student/prompt",
			links: [
				{
					text: "Prompt Analysis",
					section: STUDENT_PROMPT_ANALYSIS,
				},
				{
					text: "Constructed Response Analysis",
					section: STUDENT_CR_PROMPT_ANALYSIS,
				},
			],
		},
		{
			heading: "Progress",
			Icon: ProgressIcon,
			link: "/reports/student/progress",
			links: [
				{
					text: "Average Monthly Scores",
					section: STUDENT_AVERAGE_MONTHLY_SCORES,
				},
				{
					text: "Essay Draft History",
					section: ESSAY_DRAFT_HISTORY_SECTION,
				},
			],
		},
	];

	return (
		<section>
			<div className="flex justify-between">
				<div className="w-3/4">
					<h1>Student Reports</h1>
				</div>
				<SelectDevelopmentView
					value={view}
					setValue={(v) => setView(v as string)}
					simpleListBoxId="viewFilter"
					options={[
						{ value: "legacy", label: "Legacy" },
						{ value: "raw", label: "Raw Data" },
					]}
					fieldClasses="w-64"
				/>
			</div>
			{view == "legacy" && data && (
				<div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4">
					{reportBlocks.map((b, index) => (
						<ReportBlock block={b} key={index} className="md:!min-h-36" />
					))}
				</div>
			)}
			{view == "raw" && <RtkqResultViewer heading="Report View Data" result={result} />}
		</section>
	);
}
